export default __webpack_public_path__ + "a0fd542e75124e4595aada5c976f0287.svg";